var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top_info top_info_container fees"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("burned fees")]), _c('p', {
    staticClass: "content"
  }, [_vm.burnedFees ? _c('span', {
    staticClass: "usd-before"
  }, [_vm._v(_vm._s(_vm.inUSD.toFixed(2)) + " USD")]) : _c('span', [_vm._v("N/A")])]), _c('p', {
    staticClass: "description"
  }, [_c('img', {
    staticStyle: {
      "filter": "drop-shadow(2px 4px 6px black)",
      "margin-right": "10px"
    },
    attrs: {
      "src": require("@/assets/lit.svg")
    }
  }), _vm.burnedFees ? _c('span', {
    staticClass: "dcm-after"
  }, [_vm._v(_vm._s(_vm.burnedFees.burned.toFixed(9)))]) : _c('span', [_vm._v("N/A")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }